<template>
    <router-link tag="a" v-if="product" class="product-list" :to="`/shop/products/${product._id}`">
        <span class="product-list__thumb">
            <span class="product-list__thumbnail">
                <span class="product-list__thumbnail-image" :style="{ backgroundImage: `url('${product.thumb}')` }"></span>
            </span>
            <span class="product-list__thumb-image"></span>
        </span>
        <span class="product-list__brand" v-if="product.store">{{ product.store.meta.companyName }}</span>
        <span class="product-list__title">{{ product.name }}</span>
        <!-- <span class="product-list__price">
            <span v-if="product.discountPrice" class="product-list__price-percent">{{ product.discountRate }}%</span>
            <em v-if="product.soldout || product.stock == 0" class="product-list__price-num">품절</em>
            <em v-else class="product-list__price-num">{{ product.salePrice.format() }}원</em>
            <small v-if="product.discountPrice" class="product-list__price-line">{{ product.price.format() }}원</small>
        </span> -->
        <span class="product-list__price">
            <small class="product-list__price-text">회원가</small>
            <small v-if="product.discountEnabled" class="product-list__price-line product-list__price-line--top">{{ product.price.format() }}원</small>
            <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.discountRate }}%</span>
            <em class="product-list__price-num">{{ product.salePrice.format() }}원</em>
        </span>
        <span v-if="scope.includes('company')" class="product-list__price">
            <small class="product-list__price-text">업체가</small>
            <small v-if="product.discountEnabled" class="product-list__price-line product-list__price-line--top">{{ product.companyPrice.format() }}원</small>
            <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.companyDiscountRate }}%</span>
            <em class="product-list__price-num">{{ product.companySalePrice.format() }}원</em>
        </span>
        <span v-if="product.shipping.code == 'free'" class="product-list__groups">
            <span class="product-list__group product-list__group--grey">무료배송</span>
        </span>
    </router-link>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            product: null,
        };
    },
    created() {
        this.product = this.value;
    },
    watch: {
        value() {
            this.product = this.value;
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
    },
};
</script>
